export default "__VITE_ASSET__BUoUQRSw__"